import { useState, useEffect } from "react";
import { IStaff } from "../types/types";
import { fetchStaff } from "../services/services";
import { StaffContext } from "./context";

export const StaffProvider = ({ children }: { children: React.ReactNode }) => {
  const [staff, setStaff] = useState<IStaff[]>();

  useEffect(() => {
    async function getStaff() {
      try {
        const people = await fetchStaff();
        setStaff(people);
      } catch (error) {
        console.log(error);
      }
    }
    void getStaff();
  }, []);
  return <StaffContext.Provider value={staff}>{children}</StaffContext.Provider>;
};
